RivalIQ.apps.AdsInsights.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.FbAdObjectsCollection = Backbone.Collection.mixin({

        mixins: {
            FetchByPostMixin: RivalIQ.utils.FetchByPostMixin
        },

        url: function () {
            return `/api/accounts/${RivalIQ.state.account.get('id')}/insights/facebook/ads`;
        }
    });
});
